import util from '@bmp-vue/core/api/util'

const controller = 'Autenticacao'

export default Object.assign({}, util.GetCrud(controller, null), {
  AutenticarOperador: function (login, senha, tokenCaptcha) {
    var dto = { Login: login, Senha: senha, TokenCaptcha: tokenCaptcha }
    return util.Axios.Post(controller + '/Operador/AccessToken', dto)
  },
  Logout: function () {
    return util.Axios.Delete(controller + '/Operador/AccessToken')
  },
  RefreshToken: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post(controller + '/Operador/RefreshToken', dto)
  },
  RevokeRefreshToken: function (token) {
    return util.Axios.Delete(controller, token)
  },
  GetParceiros: function (dto) {
    return util.Axios.Get(controller + '/Operador/GetParceiros', dto)
  },
  AuthCompany: function ({ token, parceiro, codigoAutenticacaoFacial, codigoSubparceiro }, headers) {
    var dto = {
      RefreshToken: token,
      CodigoParceiro: parceiro,
      CodigoAutenticacaoFacial: codigoAutenticacaoFacial,
      CodigoSubparceiro: codigoSubparceiro
    }

    return util.Axios.Post(controller + '/Operador/AuthCompany', dto, headers)
  },
  SolicitarValidacaoChave: function (dto) {
    return util.Axios.Get(controller + '/mfafisico/solicitar/validacao')
  },
  ValidarToken: function (challengeResponse) {
    return util.Axios.Post(controller + '/mfafisico/validar', challengeResponse)
  },
  GerarBiometriaFacial: function (codigoParceiro) {
    var dto = { codigoParceiro: codigoParceiro }
    return util.Axios.Post(controller + '/Operador/gerar-biometria-facial', dto)
  },
  ObterReferenceTokenMultiplo(dataExpiracaoToken) {
    var dto = {dataExpiracaoToken: dataExpiracaoToken}
    return util.Axios.Post(controller + '/reference-token', dto)
  }
})
